import React from "react";
import styled from "styled-components";

import { Img, Text, Col } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { notFound404 } from "../../theme/uploaded";

const Wrapper = styled(Col)`
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #fff;
`;

export default ({ message }) => {
  return (
    <Wrapper>
      <Img width="30%" src={notFound404} />
      <Text fontSize="16px" fontWeight={600} color={Theme.color.GRAY_1}>
        {message}
      </Text>
    </Wrapper>
  );
};
